'use strict';

/**
 * Detail view ffor the album selection
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var JqueryMouseWheel = require('vendor/jquery.mousewheel-3.1.13');
var Hammer = require('vendor/hammer-2.0.4');
var jQueryHammer = require('vendor/jquery.hammer');

var template = require('../../templates/layout/detail-modal.hbs');

var DetailModalView = ColidoLayoutView.extend({
    template: template,

    className: 'detail-modal',

    ui: {
        actionClose: '[data-action="close"]',
        slider: '.image-slider',
        sliderPager: '.image-slider-pager',
        sliderImages: '.image-slider img',
        images: '.image',
        imagesTags: '.image img',
        imageWrapper: '.images-wrapper',
        imageBoxes: '.image-box',
        video: 'video',
        videoPlayButton: '.btn-play[data-action="play-video"]',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
        'click @ui.videoPlayButton': 'playVideo',
    },

    viewData: {
        model: function() {
            return this.model;
        },

        images: function() {
            return this.model.get('images');
        },
    },

    /**
     * Array for the transform matrices of the images
     * @var {Array}
     */
    transformMatrices: [],

    /**
     * Array for the hammer control handling
     * @var {Array}
     */
    hammerManager: [],

    /**
     * Index of the image, that is currently shown
     */
    currentImage: null,

    initialize: function(options) {
        ColidoLayoutView.prototype.initialize.apply(this, arguments);
        this.resetMatrices();
    },

    /**
     * Callback for redering process
     * @return {void}
     */
    onShow: function() {
        this.ui.imagesTags.on('load error', function(event) {
            $(event.currentTarget).closest('.image').removeClass('loading');
        }.bind(this));

        // Bind video events
        this.ui.video.on('play', this.onPlayVideo.bind(this));
        this.ui.video.on('pause stop', this.onStopVideo.bind(this));

        _.delay(function() { // We need some delay for a good visual effect
            // Setup boxes
            this.setupImageBoxes();

            // Create slider, when there are more than one image
            if (this.ui.sliderImages.length > 1) {
                this.ui.slider.on('init', function(slick) {
                    this.ui.slider.find('video').each(function(index, video) {
                        video.play();
                    })
                }.bind(this));

                this.ui.slider.slick({
                    infinite: false,
                    speed: 500,
                    variableWidth: false,
                    touchThreshold: 10,
                    arrows: true,
                    nextArrow: this.$('.slide-next'),
                    prevArrow: this.$('.slide-prev'),
                    dots: true,
                    initialSlide: this.getOption('slyPage') || 0,
                });

                this.ui.slider.on('mousedown', function(event) {
                    this.ui.slider.find('.slick-track').addClass('slick-dragged');
                }.bind(this));

                this.ui.slider.on('mouseup', function(event) {
                    this.ui.slider.find('.slick-track').removeClass('slick-dragged');
                }.bind(this));

                this.ui.slider.on('beforeChange', function(event) {
                    this.currentImage = null;
                    this.resetMatrices(true);
                }.bind(this));
            }

            // Events to listen for
            this.ui.imagesTags.on('mousewheel', this.handleZoom.bind(this));
            this.ui.imagesTags.each(function(n, el) {
                var mc = new Hammer.Manager(el);
                mc.add([
                    new Hammer.Pinch(),
                    new Hammer.Pan(),
                    new Hammer.Tap({event: 'doubletap', taps: 2}),
                ]);
                mc.on('pinchstart pinchmove pinchend panstart panmove panend doubletap', this.handleZoom.bind(this));

                this.hammerManager.push(mc);
            }.bind(this));

            // Update image transformations
            this.updateImageTransforms();

            this.ui.slider.addClass('is-ready');
        }.bind(this), 400);
    },

    /**
     * Resize callback
     */
    onResize: function() {
        this.setupImageBoxes();
    },

    /**
     * Sets up proper image boxes
     */
    setupImageBoxes: function() {
        var sliderHeight = this.ui.slider.height() - this.getPxSize(4);
        var sliderWidth  = this.ui.slider.width() - this.getPxSize(4);

        this.ui.imageBoxes.each(function(n, box) {
            box = $(box);
            var ratio = parseFloat(box.data('ratio'));

            if (ratio > 1) {
                var width = sliderWidth;
                var height = Math.floor(sliderWidth / ratio);

                if (height > sliderHeight) {
                    height = sliderHeight;
                    width  = height * ratio;
                }

                box.css({
                    width: width + 'px',
                    height: height + 'px',
                    marginLeft: Math.floor(width / -2) + 'px',
                    marginTop: Math.floor(height / -2) + 'px',
                });
            } else {
                var width = Math.floor(sliderHeight * ratio);
                var height = sliderHeight;

                if (width > sliderWidth) {
                    width = sliderWidth;
                    height = width / ratio;
                }

                box.css({
                    width: width + 'px',
                    height: height + 'px',
                    marginLeft: Math.floor(width / -2) + 'px',
                    marginTop: Math.floor(height / -2) + 'px',
                });
            }
        }.bind(this));
    },

    /**
     * Handles the zoom events for an image
     * @param {object} event The event object (mouswheel / touchstart / mousedown ...)
     */
    handleZoom: function(event) {
        if (event.srcEvent) {
            event.srcEvent.preventDefault();
        } else {
            event.preventDefault();
        }

        var curTarget = $(event.target);
        var idx = curTarget.closest('.image').data('idx');

        // Set current image
        this.currentImage = idx;

        // Fetch matrix
        var matrix = this.transformMatrices[idx];

        switch (event.type) {
            // Mouswheel
            case 'mousewheel':
                if (event.deltaY > 0) {
                    matrix.scale += 0.1;
                } else {
                    matrix.scale -= 0.1;
                }

                matrix.lastScale = matrix.scale;
                break;

            // Tap
            case 'doubletap':
                if (event.srcEvent.shiftKey) {
                    matrix.scale -= 1;
                } else {
                    matrix.scale += 1;
                }

                matrix.lastScale = matrix.scale;
                break;

            // Drag/Pan
            case 'panstart':
                matrix.isDrag = true;
                this.ui.slider.toggleClass('transition-disabled', true);
                break;

            case 'panmove':
                if (matrix.isDrag && matrix.scale > 1) {
                    matrix.offsetX = event.deltaX + matrix.lastX;
                    matrix.offsetY = event.deltaY + matrix.lastY;
                }
                break;

            case 'panend':
                matrix.isDrag = false;
                matrix.lastX = matrix.offsetX;
                matrix.lastY = matrix.offsetY;
                this.ui.slider.toggleClass('transition-disabled', false);
                break;

            // Pinchzoom
            case 'pinchstart':
                matrix.isPinch = true;
                this.ui.slider.toggleClass('transition-disabled', true);
                break

            case 'pinchmove':
                if (matrix.isPinch) {
                    matrix.scale = event.scale * matrix.lastScale;
                }
                break;

            case 'pinchend':
                matrix.isPinch = false;
                matrix.lastScale = matrix.scale;
                this.ui.slider.toggleClass('transition-disabled', false);
                break;
        }

        // Scale bounds
        if (matrix.scale > 10) {
            matrix.scale = matrix.lastScale = 10;
        } else if (matrix.scale < 1) {
            matrix.scale = matrix.lastScale = 1;
        }

        // Reset everything
        if (matrix.scale == 1) {
            this.resetMatrices();
        }

        // Stop propagation?
        if (matrix.scale > 1) {
            // Disable slick
            if (_.isObject(this.ui.slider)
                && this.ui.slider.length > 0
                && this.ui.imagesTags.length > 1
                && this.ui.slider.slick
            ) {
                this.ui.slider.slick('slickSetOption', 'draggable', false);
            }

            if (event.srcEvent) {
                event.srcEvent.stopPropagation();
            } else {
                event.stopPropagation();
            }
        }
    },

    /**
     * Resets the transform matrices
     * @param {boolean=} resetTransform (Optional) Reset transform on images?
     */
    resetMatrices: function(resetTransform) {
        resetTransform = resetTransform || false;

        var images = this.model.get('images');
        for (var i = 0; i < images.length; i++) {
            this.transformMatrices[i] = {
                scale: 1,
                lastScale: 1,
                offsetX: 0,
                offsetY: 0,
                lastX: 0,
                lastY: 0,
                isDrag: false,
                isPinch: true,
            };
        }

        if (resetTransform) {
            this.ui.imagesTags.removeAttr('style');
        }

        // Re-enable slider drag
        if (_.isObject(this.ui.slider)
            && this.ui.slider.length > 0
            && this.ui.imagesTags.length > 1
            && this.ui.slider.slick
        ) {
            this.ui.slider.slick('slickSetOption', 'draggable', true);
        }
    },

    /**
     * Updates the image transformations inside of an animation frame
     */
    updateImageTransforms: function() {
        // Return if view is destroyed
        if (this.isDestroyed) {
            return;
        }

        if (this.currentImage !== null) {
            this.ui.imagesTags.each(function(idx, image) {
                if (idx == this.currentImage) {
                    image = $(image);

                    var matrix = this.transformMatrices[idx];
                    var imageWrapper = image.closest('.image');

                    // Check boundaries
                    if (matrix.scale > 1) {
                        var wrapperOffset = imageWrapper.offset();
                        var wrapperWidth = imageWrapper.width();
                        var wrapperHeight = imageWrapper.height();
                        var imageOffset = image.offset();
                        var imageWidth = image.width() * matrix.scale;
                        var imageHeight = image.height() * matrix.scale;
                        var hitLeftBoundary = false;
                        var hitTopBoundary = false;
                        var needsWidthBoundary = imageWidth > wrapperWidth;
                        var needsHeightBoundary = imageHeight > wrapperHeight;

                        // Check left boundary
                        if (needsWidthBoundary && imageOffset.left > wrapperOffset.left) {
                            var diffX = imageOffset.left - wrapperOffset.left;
                            matrix.offsetX -= diffX;
                            matrix.lastX -= diffX;
                            hitLeftBoundary = true;
                        }

                        // Check top boundary
                        if (needsHeightBoundary && imageOffset.top > wrapperOffset.top) {
                            var diffY = imageOffset.top - wrapperOffset.top;
                            matrix.offsetY -= diffY;
                            matrix.lastY -= diffY;
                            hitTopBoundary = true;
                        }

                        // Check right boundary
                        if (needsWidthBoundary
                            && !hitLeftBoundary
                            && (imageWidth + imageOffset.left < wrapperWidth + wrapperOffset.left)
                        ) {
                            var diffX = (imageWidth + imageOffset.left) - (wrapperWidth + wrapperOffset.left);
                            matrix.offsetX -= diffX;
                            matrix.lastX -= diffX;
                        }

                        // Check bottom boundary
                        if (needsHeightBoundary
                            && !hitTopBoundary
                            && (imageHeight + imageOffset.top < wrapperHeight + wrapperOffset.top)
                        ) {
                            var diffY = (imageHeight + imageOffset.top) - (wrapperHeight + wrapperOffset.top);
                            matrix.offsetY -= diffY;
                            matrix.lastY -= diffY;
                        }

                        // Align to middle when no boundary is needed
                        if (!needsWidthBoundary) {
                            matrix.offsetX = matrix.lastX = 0;
                        }

                        if (!needsHeightBoundary) {
                            matrix.offsetY = matrix.lastY = 0;
                        }
                    }

                    // Perform transform
                    var transform =
                        'translate3d(' + matrix.offsetX  + 'px, ' + matrix.offsetY + 'px, 0) ' +
                        'scale3d(' + matrix.scale + ',' + matrix.scale + ', 1) ';
                    image.css('transform', transform);
                }
            }.bind(this));
        }

        requestAnimationFrame(this.updateImageTransforms.bind(this));
    },

    /**
     * Destroys the attached slider
     */
    destroySlider: function() {
        if (!this.isDestroyed) {
            for (var i = 0; i < this.hammerManager.length; i++) {
                this.hammerManager[i].destroy();
            }

            if (_.isObject(this.ui.imagesTags) && this.ui.imagesTags.length > 0) {
                this.ui.imagesTags.off();
            }

            if (_.isObject(this.ui.slider)
                && this.ui.slider.length > 0
                && this.ui.imagesTags.length > 1
                && this.ui.slider.slick
            ) {
                this.ui.slider.slick('unslick');
                this.ui.slider.off();
            }
        }
    },

    /**
     * Destroy plugins and additional listener
     */
    onBeforeDestroy: function() {
        this.destroySlider();

        // Reset Arrays
        this.hammerManager = [];
        this.transformMatrices = [];
        this.ui.video.off();
    },

    actionClose: function(event) {
        this.trigger('close:modal');
    },

    onPlayVideo: function(event) {
        $(event.currentTarget).addClass('is-playing');
    },

    onStopVideo: function(event) {
        $(event.currentTarget).removeClass('is-playing');
    },

    playVideo: function(event) {
        event.stopPropagation();
        var curTarget = $(event.currentTarget);
        var video = curTarget.prev();

        if (video.is('video')) {
            video[0].play();
        }
    },
});

module.exports = DetailModalView;